// extracted by mini-css-extract-plugin
module.exports = {"boxContain":"styles_boxContain__3NCw-","colorContainer":"styles_colorContainer__148a-"};